import type { EnvironmentNextScheduledDates } from 'types/api.types';
import type { SchedulingApi } from '@env0/scheduling-service/api';

type EnvironmentNextScheduleAction = {
  actionType: Exclude<SchedulingApi.ActionType, 'DRIFT_DETECTION'>;
  date: Date;
};

export const getNextSchedule = (nextScheduledDates: EnvironmentNextScheduledDates): EnvironmentNextScheduleAction => {
  const { deploy, destroy } = nextScheduledDates;

  if (!deploy || (destroy && deploy > destroy)) {
    return { actionType: 'DESTROY', date: destroy! };
  } else {
    return { actionType: 'DEPLOY', date: deploy };
  }
};

export const getCountdownTitle = (dates: EnvironmentNextScheduledDates | null) =>
  `environment.description.field.${dates ? 'next.schedule' : 'time.left'}`;

// nextScheduledDates can be an object with no dates in it: process-schedule-due-event.ts spreads
// `{ [actionType]: record.nextSchedule }` over it, and nextSchedule is optional once a one-off
// schedule is due. The backend reads the same field with _.isEmpty (environment-service
// functions/commons/ttl.ts), so an object with no date means no scheduling here too.
export const hasScheduling = (nextScheduledDates?: EnvironmentNextScheduledDates | null) =>
  !!(nextScheduledDates?.deploy || nextScheduledDates?.destroy);
